<ul class="ob1-item-card-list apply-one-grid apply-one-style mb-2 mt-2">
  <li>
    <div
      class="alert-container ob1-notification-message alert-info no-border"
      [attr.data-e2e]="'e2e-recommendation-' + viewModel?.code"
    >
      <a
        ecmPushTracker
        [ecmDisabledAction]="isEclair && !AdviseWhitelistEclairConstants.WHITELIST.includes(viewModel?.code?.toUpperCase())"
        [attr.data-e2e]="'e2e-recommendation-btn-' + viewModel?.code"
        [attr.id-ref-zone]="viewModel?.idRefZone"
        [attr.abc-track-cible]="linkService.getLinkSync(viewModel?.link)"
        [attr.abc-track-nom]="viewModel?.trackingData?.tmsTracking?.trackingName"
        [attr.abc-track-zone]="viewModel?.trackingData?.tmsTracking?.trackingArea"
        [href]="linkService.getLinkSync(viewModel?.link)"
        [pdb-zid]="zid"
        [pdb-sc]="'adv'"
        [pdb-ta]="viewModel.advTracker"
        [pdb-idc]="viewModel?.code"
        class="ob1-item-card alert-info px-1 px-md-1 no-border"
        (click)=" openRelationalLink()"
      >
        @if (viewModel.imageUrl) {
        <img alt="" class="push-info-icon" [src]="getImgFormat(viewModel.imageUrl)" />
        } @if (!viewModel.imageUrl) {
        <span class="icon icon-info push-info-icon" aria-hidden="true"></span>
        }
        <div class="ob1-item-card-container">
          <div class="ob1-item-card-text">
            <strong>{{ viewModel.title }}</strong>
            <small class="ob1-item-card-desc push-info-desc text-mw"> {{ viewModel.content }} </small>
          </div>
        </div>
      </a>
    </div>
  </li>
</ul>
